export default {
      id: "ic_smartbanner_bilyoner_icon-usage",
      viewBox: "0 0 524.1 524.1",
      url: "/" + "images/icons.3.109.2.svg#ic_smartbanner_bilyoner_icon-usage",
      toString: function () {
        return this.url;
      }
    }